import React, { Component } from 'react';
import { EditProfileProps, EditProfileState } from '../../interfaces/user'
import { connect } from 'react-redux'
import Topbar from '../topbar/topbar'
import Sidebar from '../sidebar/sidebar'
import Footer from '../footer/footer'
import 'react-tabs/style/react-tabs.css';
import { getUserProfile, logoutUser, updatePassword, updateProfile } from '../../redux/actions/user';
import { validatePassword } from '../../utils/passwordValidation';
import config from '../config/setting'
import { withAuth } from '../withAuth';
import { IMAGE_URL } from '../../client-config';

class Profile extends Component<EditProfileProps, EditProfileState> {
    id: any;
    constructor(readonly props: any) {
        super(props);
        this.id = this.props.match.params.id;
        this.state = {
            name: "",
            email: "",
            phone: "",
            address: "",
            designation: "",
            profileImage: "",
            changePassMsg: "",
            newPass: "",
            confirmPass: "",
            passwordStrength: 0,
            passwordErrors: [],
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.props.getUserProfile(this.id);
        document.title = "Simplex Services | Profile"
        console.log("IMAGE_URL:", IMAGE_URL);
    }
    componentWillReceiveProps(nextProps: any) {
        this.setState({
            name: nextProps.user.name,
            email: nextProps.user.email,
            phone: nextProps.user.phone,
            address: nextProps.user.address,
            designation: nextProps.user.designation,
            profileImage: nextProps.user.profileImage,
        });
    }
    handleInputChange(event: { target: { name: any; value: any; }; }) {
        const { name, value } = event.target;
        if (value[0] === " ") {
            return;
        }
        this.setState({
            [name]: value,
        });
    }

    handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        // Allow only letters and spaces, no numbers or special characters
        const filteredValue = value.replace(/[^A-Za-z\s]/g, '');
        // Prevent starting with space
        if (filteredValue[0] === " ") {
            return;
        }
        this.setState({
            name: filteredValue,
        });
    }

    handlePhoneKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const key = event.key;
        const currentValue = (event.target as HTMLInputElement).value;

        // Allow control keys (backspace, delete, tab, arrows)
        const controlKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
        if (controlKeys.includes(key)) {
            return;
        }

        // Block non-digit keys
        if (!/^\d$/.test(key)) {
            event.preventDefault();
            return;
        }

        // Block if already 11 digits
        if (currentValue.length >= 11) {
            event.preventDefault();
        }
    };

    handlePhoneChange = (e: any) => {
        let value = e.target.value;
        // Remove anything that's not a number
        let numericValue = value.replace(/\D/g, "");
        // Trim to max 11 digits
        if (numericValue.length > 11) {
            numericValue = numericValue.slice(0, 11);
        }

        this.setState({ phone: numericValue });
    };

    handleNewPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        if (value[0] === " ") {
            return;
        }

        const result = validatePassword(value);

        this.setState({
            newPass: value,
            passwordStrength: result.strength,
            passwordErrors: result.isValid ? [] : result.errors,
            changePassMsg: "",
        });
    }
    handleSubmit = (event: any) => {
        let { name, email, phone, address, designation, profileImage } = this.state;

        const data = new FormData();

        data.append('file', profileImage[0]);
        data.append('name', name);
        data.append('designation', designation);
        data.append('email', email);
        data.append('phone', phone);
        data.append('address', address);

        this.props.updateProfile(this.id, data);
    }
    FileSelectedHandler = (e: any) => {
        this.setState({ profileImage: e.target.files })
    }
    isFormValid = () => {
        const { name, email, phone, designation, address } = this.state;

        // Basic empty checks
        if (!name || !email || !phone || !designation || !address) {
            return false;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            return false;
        }

        // Phone validation: exactly 11 digits
        const phoneDigits = phone.replace(/\D/g, ""); // remove non-digit chars
        if (phoneDigits.length !== 11) {
            return false;
        }

        return true;
    };

    isPassFormValid = () => {
        const { newPass, confirmPass, passwordErrors } = this.state;

        if (!newPass || !confirmPass) {
            return false;
        }

        if (passwordErrors && passwordErrors.length > 0) {
            return false;
        }

        if (newPass !== confirmPass) {
            return false;
        }

        return true;
    }
    changedPassword = (event: any) => {
        event.preventDefault();
        const { newPass, confirmPass, passwordErrors } = this.state;

        if (passwordErrors && passwordErrors.length > 0) {
            this.setState({ changePassMsg: "Password does not meet the required rules." });
            return;
        }

        if (newPass !== confirmPass) {
            this.setState({ changePassMsg: "Passwords do not match" });
            return;
        }

        const data = {
            password: newPass
        };

        this.props.changePassword(this.id, data);
    }
    render() {
        let msg;
        let messcolor;
        const { isInserted, message } = this.props;
        let { user } = this.props;


        const { changePassMsg } = this.state
        if (isInserted) {
            msg = message;
            messcolor = 'green'
        } else {
            msg = message;
            messcolor = 'red'
        }
        return (
            <div className="page">
                <Topbar />
                <div className="page-content d-flex align-items-stretch">
                    <Sidebar />
                    <div className="content-inner">
                        {/* <!-- Page Header--> */}
                        <header className="page-header py-0">
                            <div className="container-fluid">
                                <div className="d-flex justify-content-between py-3">
                                    <h4 className="mt-2">Profile Management</h4>
                                </div>
                            </div>
                        </header>
                        <section className="forms">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="card">
                                            <div className="card-header d-flex align-items-center">
                                                <h3 className="h4">Personal Information</h3>
                                            </div>
                                            <div className="card-body">
                                                {true &&
                                                    <strong><p className="text-center font-weight-light mb-4" style={{ color: 'green' }}>
                                                        {message}
                                                    </p></strong>
                                                }
                                                < div>

                                                    <div className="row form-group">
                                                        <label className="col-md-3 col-sm-3 form-control-label font-weight-bold">Profile Picture</label>
                                                        <div className="col-md-9 col-sm-9">
                                                            <input id="file" type="file" name="file" className="form-control-file" onChange={this.FileSelectedHandler} />
                                                            {user.profileImage && (() => {
                                                                const imageUrl = IMAGE_URL + user.profileImage;
                                                                console.log("Profile Image Full URL:", imageUrl);

                                                                return (
                                                                    <img
                                                                        className="img-visa-passport"
                                                                        src={imageUrl}
                                                                        alt="Profile Image"
                                                                        style={{ display: 'block', marginTop: '10px', maxWidth: '200px', border: '1px solid #ddd', padding: '5px', borderRadius: '4px' }}
                                                                        onLoad={() => console.log("Image loaded successfully:", imageUrl)}
                                                                        onError={(e) => {
                                                                            console.error("Image failed to load:", imageUrl);
                                                                            console.error("Error details:", e);
                                                                        }}
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>


                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">Name<span className="text-danger">*</span></label>
                                                                {user &&
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        value={this.state.name}
                                                                        required
                                                                        data-msg="Please enter Name"
                                                                        className="input-material"
                                                                        onChange={this.handleNameChange}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">Email<span className="text-danger">*</span></label>
                                                                {user &&
                                                                    <input type="email" name="email" defaultValue={user.email} required data-msg="Please enter Email" className="input-material" onChange={this.handleInputChange} />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">Phone<span className="text-danger">*</span></label>
                                                                {user &&
                                                                    <input
                                                                        type="text"
                                                                        name="phone"
                                                                        value={this.state.phone} // controlled input
                                                                        required
                                                                        data-msg="Please enter Phone"
                                                                        className="input-material"
                                                                        onChange={this.handlePhoneChange}
                                                                        onKeyDown={this.handlePhoneKeyPress}
                                                                    />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">

                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">Designation<span className="text-danger">*</span></label>
                                                                {user &&
                                                                    <input type="text" name="designation" defaultValue={user.designation} required data-msg="Please enter Designation" className="input-material" onChange={this.handleInputChange} />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">Address<span className="text-danger">*</span></label>
                                                                {user &&
                                                                    <input type="text" name="address" defaultValue={user.address} required data-msg="Please enter Address" className="input-material" onChange={this.handleInputChange} />
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="form-group float-right">
                                                        <button onClick={this.handleSubmit} disabled={!this.isFormValid()} className="btn btn-primary">Update Profile</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="card">
                                            <div className="card-header d-flex align-items-center">
                                                <h3 className="h4">Update Password</h3>
                                            </div>
                                            <div className="card-body">
                                                {changePassMsg !== "" && (
                                                    <strong>
                                                        <p className="text-center font-weight-light mb-4" style={{ color: 'red' }}>
                                                            {changePassMsg}
                                                        </p>
                                                    </strong>
                                                )}
                                                <div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">New Password<span className="text-danger">*</span></label>
                                                                {/* 👇 Wrapped input with eye icon — rest unchanged */}
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        type={this.state.showNewPass ? "text" : "password"}
                                                                        name="newPass"
                                                                        required
                                                                        placeholder="Enter new password" // optional
                                                                        className="input-material"
                                                                        onChange={this.handleNewPasswordChange}
                                                                        value={this.state.newPass} // will be empty initially
                                                                        style={{ paddingRight: '2.25rem' }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => this.setState({ showNewPass: !this.state.showNewPass })}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            right: '0.6rem',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            background: 'transparent',
                                                                            border: 'none',
                                                                            cursor: 'pointer',
                                                                            fontSize: '1rem',
                                                                            color: '#999',
                                                                            padding: 0,
                                                                            lineHeight: 1,
                                                                        }}
                                                                        aria-label={this.state.showNewPass ? "Hide password" : "Show password"}
                                                                    >
                                                                        {this.state.showNewPass ? (
                                                                            <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                                        ) : (
                                                                            <i className="fa fa-eye" aria-hidden="true"></i>
                                                                        )}
                                                                    </button>
                                                                </div>

                                                                {this.state.newPass && (
                                                                    <div className="mt-2">
                                                                        <div className="d-flex align-items-center mb-1">
                                                                            <span
                                                                                className={`badge badge-pill ${this.state.passwordStrength && this.state.passwordStrength >= 80
                                                                                    ? "badge-success"
                                                                                    : this.state.passwordStrength && this.state.passwordStrength >= 50
                                                                                        ? "badge-warning"
                                                                                        : "badge-danger"
                                                                                    }`}
                                                                            >
                                                                                {this.state.passwordStrength && this.state.passwordStrength >= 80
                                                                                    ? "Strong password"
                                                                                    : this.state.passwordStrength && this.state.passwordStrength >= 50
                                                                                        ? "Medium password"
                                                                                        : "Weak password"}
                                                                            </span>
                                                                        </div>
                                                                        <ul className="list-unstyled mb-0 small">
                                                                            <li className={this.state.newPass.length >= 10 ? "text-success" : "text-muted"}>
                                                                                <i className={`fa ${this.state.newPass.length >= 10 ? "fa-check" : "fa-circle"} mr-1`} />
                                                                                At least 10 characters
                                                                            </li>
                                                                            <li className={/[A-Z]/.test(this.state.newPass) ? "text-success" : "text-muted"}>
                                                                                <i className={`fa ${/[A-Z]/.test(this.state.newPass) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                                At least one uppercase letter (A–Z)
                                                                            </li>
                                                                            <li className={/[a-z]/.test(this.state.newPass) ? "text-success" : "text-muted"}>
                                                                                <i className={`fa ${/[a-z]/.test(this.state.newPass) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                                At least one lowercase letter (a–z)
                                                                            </li>
                                                                            <li className={/[0-9]/.test(this.state.newPass) ? "text-success" : "text-muted"}>
                                                                                <i className={`fa ${/[0-9]/.test(this.state.newPass) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                                At least one number (0–9)
                                                                            </li>
                                                                            <li className={/[!@#$%^&*_\-+=?]/.test(this.state.newPass) ? "text-success" : "text-muted"}>
                                                                                <i className={`fa ${/[!@#$%^&*_\-+=?]/.test(this.state.newPass) ? "fa-check" : "fa-circle"} mr-1`} />
                                                                                At least one special character (! @ # $ % ^ & * _ - + = ?)
                                                                            </li>
                                                                        </ul>
                                                                        {this.state.passwordErrors && this.state.passwordErrors.length > 0 && (
                                                                            <small className="text-danger d-block mt-1">
                                                                                {this.state.passwordErrors[0]}
                                                                            </small>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <div className="form-group">
                                                                <label className="form-control-label">Confirm Password<span className="text-danger">*</span></label>
                                                                {/* 👇 Same for confirm — only this block changed */}
                                                                <div style={{ position: 'relative', width: '100%' }}>
                                                                    <input
                                                                        type={this.state.showConfirmPass ? "text" : "password"}
                                                                        name="confirmPass"
                                                                        placeholder="Enter confirm password"
                                                                        required
                                                                        data-msg="Please enter confirm password"
                                                                        className="input-material"
                                                                        onChange={this.handleInputChange}
                                                                        style={{ paddingRight: '2.25rem' }}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => this.setState({ showConfirmPass: !this.state.showConfirmPass })}
                                                                        style={{
                                                                            position: 'absolute',
                                                                            right: '0.6rem',
                                                                            top: '50%',
                                                                            transform: 'translateY(-50%)',
                                                                            background: 'transparent',
                                                                            border: 'none',
                                                                            cursor: 'pointer',
                                                                            fontSize: '1rem',
                                                                            color: '#999',
                                                                            padding: 0,
                                                                            lineHeight: 1,
                                                                        }}
                                                                        aria-label={this.state.showConfirmPass ? "Hide password" : "Show password"}
                                                                    >
                                                                        {this.state.showConfirmPass ? (
                                                                            <i className="fa fa-eye-slash" aria-hidden="true"></i>
                                                                        ) : (
                                                                            <i className="fa fa-eye" aria-hidden="true"></i>
                                                                        )}
                                                                    </button>
                                                                </div>

                                                                {this.state.confirmPass &&
                                                                    this.state.newPass &&
                                                                    this.state.confirmPass !== this.state.newPass && (
                                                                        <small className="form-text text-danger">
                                                                            Passwords do not match.
                                                                        </small>
                                                                    )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-group float-right">
                                                        <button
                                                            onClick={this.changedPassword}
                                                            disabled={!this.isPassFormValid()}
                                                            className="btn btn-primary"
                                                        >
                                                            Update Password
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </div>

                </div>
            </div >
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        user: state.user.userGet,
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        getUserProfile: function (id: any) {
            dispatch(getUserProfile(id));
        },
        updateProfile: function (id: any, data: any) {
            dispatch(updateProfile(id, data));
        },
        changePassword: function (id: any, data: any) {
            dispatch(updatePassword(id, data));
        },
        logoutUser: function () {
            dispatch(logoutUser());
        },

    }
}
export default withAuth(connect(mapStateToProps, mapDispatchToProps)(Profile));